import * as React from 'react';

import { Box } from '@mui/material';

import { LoadingSpinner } from '@modules/_shared/components/LoadingSpinner';

type ImageLoadingOverlayProps = {
  visible: boolean;
};

export const ImageLoadingOverlay = React.memo(
  ({ visible }: ImageLoadingOverlayProps) => {
    if (!visible) {
      return null;
    }

    return (
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
        }}
      >
        <Box
          sx={{
            bgcolor: 'background.paper',
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <LoadingSpinner />
        </Box>
      </Box>
    );
  },
);
